import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import swal from 'sweetalert'
import { alertDeleteQuestion, deleteQuestion, dontDeleteQuestion } from '../../../directories/collections';
import { CantComments, delQuestion, updateQuestion } from '../../../helpers/contenido';
import { delQuestionById, setQuestionById } from '../../../reducer/ContenidoReducer';
import Loading from '../../tools/Loading';
const PreguntaComponent = ({data,email, idAsig, idTema}) => {
    const dispatch = useDispatch();
    const {question,id} = data
    const [edit, setedit] = useState(false);
    const [questionEdit, setQuestionEdit] = useState(question);
    const [loadingQuestion, setloadingQuestion] = useState(false);
    const [cantComentarios, setCantComentarios] = useState(0);


    const handleDeleteQuestion = () => {
        swal(alertDeleteQuestion)
          .then((willDelete) => {
            if (willDelete) {
              swal(deleteQuestion, {
                icon: "success",
              });
              delQuestion(email,idAsig,idTema,id)
              .then(() => dispatch(delQuestionById(id)))
            } else {
              swal(dontDeleteQuestion);
            }
          });
    }

    const handleUpdateQuestion = () => {
        setloadingQuestion(true)
        updateQuestion(email,idAsig,idTema,id,questionEdit)
        .then(() => {
            dispatch(setQuestionById(id,questionEdit))
            setloadingQuestion(false)
        })
    }


    useEffect(() => {
        CantComments(email,idAsig,questionEdit)
        .then(cantidad => {
            setCantComentarios(cantidad)
        })
        return () => {
            setCantComentarios(0)
        }
    }, [email,idAsig,questionEdit])

    return (
        <div className='card_item'>
            <div className='card_header'>
                {
                    edit
                    ?   
                        <>
                            <input type='text' 
                                name='questionUp' value={questionEdit} 
                                onChange={(e) => setQuestionEdit(e.target.value)}
                            />
                            {
                                loadingQuestion
                                ?
                                    <Loading/>
                                :
                                    <>
                                        <i className="btn fas fa-save" onClick={handleUpdateQuestion} />
                                        <i className="btn fas fa-window-close"  onClick={() => setedit(!edit)} />
                                    </>

                            }
                        </>
                    :
                        <>
                            <h3>{question}</h3>
                            <i className='far fa-edit' onClick={() => setedit(!edit)} />
                            <i  className='fas fa-trash' onClick={handleDeleteQuestion}></i>
                        </>
                }
                
            </div>
            <div className='card_body'>
                <h4>Respuestas: {cantComentarios}</h4>
                <h4>Ver Respuestas: <Link to={`/asignatura/respuestas/${idAsig}/${idTema}/${id}/${question}`} className='far fa-eye' /></h4>
            </div>
        </div>
    )
}

export default PreguntaComponent
